(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-additoryx-slideshow]:not([data-additoryx-ready])').forEach((slider) => {
      slider.dataset.additoryxReady = 'true';
      const slides = [...slider.querySelectorAll('[data-additoryx-slide]')];
      const dots = [...slider.querySelectorAll('[data-additoryx-dot]')];
      const previous = slider.querySelector('[data-additoryx-previous]');
      const next = slider.querySelector('[data-additoryx-next]');
      const pause = slider.querySelector('[data-additoryx-pause]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = slider.dataset.autoplay === 'true' && !reduceMotion;
      const interval = Number(slider.dataset.interval) || 6000;
      let current = 0;
      let timer;
      let manuallyPaused = false;
      let touchStart = 0;

      const show = (index, userInitiated = false) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.querySelector('a')?.setAttribute('tabindex', active ? '0' : '-1');
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (userInitiated) restart();
      };

      const stop = () => {
        window.clearInterval(timer);
        timer = undefined;
      };
      const start = () => {
        stop();
        if (autoplay && !manuallyPaused && slides.length > 1) timer = window.setInterval(() => show(current + 1), interval);
      };
      const restart = () => {
        stop();
        start();
      };

      previous?.addEventListener('click', () => show(current - 1, true));
      next?.addEventListener('click', () => show(current + 1, true));
      dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.additoryxDot), true)));
      pause?.addEventListener('click', () => {
        manuallyPaused = !manuallyPaused;
        pause.setAttribute('aria-label', manuallyPaused ? 'Play slideshow' : 'Pause slideshow');
        pause.querySelector('span').textContent = manuallyPaused ? '▶' : 'Ⅱ';
        manuallyPaused ? stop() : start();
      });
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      slider.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', (event) => {
        const distance = event.changedTouches[0].clientX - touchStart;
        if (Math.abs(distance) > 50) show(current + (distance < 0 ? 1 : -1), true);
      }, { passive: true });
      slider.addEventListener('shopify:block:select', (event) => {
        const selected = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (selected >= 0) { manuallyPaused = true; stop(); show(selected); }
      });
      start();
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initialize()) : initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
